export default __webpack_public_path__ + "static/media/item1.cdf1d527.png";